import axios from 'axios'

import { Routes } from '~/api/api-routes'

import { Roles } from '../../admin/js/utils/enums/roles'
import store from '~/store'
import util from '~/util'

export default async (to, from, next) => {
  if (store.getters['auth/check']) {
    if ([Roles.ADMIN, Roles.SUPPORT, Roles.SOURCING_MANAGER].includes(store.getters['auth/user'].role_id)) {
      window.location = config.adminurl + '/users'
    } else if (store.getters['auth/user'].role_id === Roles.SUPPLIER) {
      window.location = config.supplierurl + '/orders'
    }
    next()
  } else {
    const review_app_login = await axios.get(Routes.userProfile.attemptToLoginAsReviwer)
    const hostname = window.location.hostname

    if (
      review_app_login['data']['response'] == 'success' &&
      hostname.substring(hostname.indexOf('.')) == '.herokuapp.com'
    ) {
      store.dispatch('auth/updateUser', { user: review_app_login['data']['user'] })
      store.dispatch('auth/saveToken', { token: review_app_login['data']['token'] })
      next()
    } else {
      const partner = to.query?.partner || new URLSearchParams(document.location.search)?.get('partner')

      if (util.getAffiliateUrl(partner)) {
        window.location = util.getAffiliateUrl(partner)
        return
      }

      // Allow access to the /product page without authentication
      if (to.path.startsWith('/product') && to?.params?.id) {
        next() // Allow access to the product page
      } else {
        // Redirect to the login page for any other route
        const currentUrl = window.location.href
        window.location = `${config.public_url}/login?continue=${encodeURIComponent(currentUrl)}`
      }
    }
  }
}
